/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SelectionBox from './SelectionBox';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

const ProcedureResultForm = ({
  values,
  onChangeValues,
  handleChangeDate,
  searchProcedureResult,
  ProcedureTypeDropDown,
  fieldLevelError,
  spinner,
  dateValideation,
}) => {
  return (
    <div className="tBillPanel custom-check">
      <Spinner load={spinner} />
      <div className="panel tBillPanel-space pb-0">
        <div className="panel mb-3">
          <div className="row">
            <div className="col-sm-8">
              <fieldset
                className="custom-fieldset"
                style={{ paddingRight: '0px' }}
              >
                <legend
                  className="same-font-family"
                  tabIndex={0}
                  id="DateRangeLabel"
                >
                  Date Range Option
                </legend>
                <div>
                  <div className="sub-radio no-margin override-width-95">
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="DateRangeLabel"
                        name="date-range-option"
                        defaultValue={values.dateRangeOptionRadio}
                      >
                        <FormControlLabel
                          style={{ marginRight: '5px' }}
                          value="All"
                          control={
                            <Radio
                              onChange={(e) => {
                                onChangeValues(e, 'dateRangeOptionRadio');
                              }}
                            />
                          }
                          label="All"
                          data-test="radio-all"
                        />
                        <FormControlLabel
                          value="selectedDateRange"
                          control={
                            <Radio
                              onChange={(e) => {
                                onChangeValues(e, 'dateRangeOptionRadio');
                              }}
                            />
                          }
                          label="Selected Date Range"
                          data-test="radio-Selected"
                        />
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md override-width-95">
                            <KeyboardDatePicker
                              data-test="start-date"
                              id="begindate-picker-dialog"
                              label="Start Date"
                              format="MM/dd/yyyy"
                              tabIndex={0}
                              className="mandate-fields"
                              value={
                                values.dateRangeOptionRadio === 'All'
                                  ? null
                                  : values.dateRangeOptionStartDate
                              }
                              onBlur={(date) => {
                                dateValideation(date, 'onBlur', 'startDt');
                              }}
                              onChange={(e) => {
                                handleChangeDate(e, 'dateRangeOptionStartDate');
                              }}
                              placeholder="mm/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              helperText={fieldLevelError.startDate}
                              error={fieldLevelError.startDate}
                              disabled={values.dateRangeOptionRadio === 'All'}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              required
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md override-width-95">
                            <KeyboardDatePicker
                              data-test="end-date"
                              id="endDate-picker-dialog"
                              tabIndex={0}
                              label="End Date"
                              format="MM/dd/yyyy"
                              className="mandate-fields"
                              value={
                                values.dateRangeOptionRadio === 'All'
                                  ? null
                                  : values.dateRangeOptionEndDate
                              }
                              onChange={(date) => {
                                handleChangeDate(
                                  date,
                                  'dateRangeOptionEndDate'
                                );
                              }}
                              placeholder="mm/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              helperText={fieldLevelError.endDate}
                              error={fieldLevelError.endDate}
                              disabled={values.dateRangeOptionRadio === 'All'}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              onBlur={(date) => {
                                dateValideation(date, 'onBlur', 'endDt');
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend
                  className="same-font-family"
                  tabIndex={0}
                  id="ProcedureTypelabel"
                >
                  Procedure Type
                </legend>

                <div className="form-wrapper db">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="ProcedureTypelabel"
                        name="procedure-type"
                        defaultValue={values.procedurTypeRadio}
                      >
                        <FormControlLabel
                          style={{ marginRight: '5px' }}
                          value="All"
                          control={
                            <Radio
                              onChange={(e) => {
                                onChangeValues(e, 'procedurTypeRadio');
                              }}
                            />
                          }
                          label="All"
                          data-test="procedure-type-all"
                        />
                        <FormControlLabel
                          value="SelcectedDateRange"
                          control={
                            <Radio
                              onChange={(e) => {
                                onChangeValues(e, 'procedurTypeRadio');
                              }}
                            />
                          }
                          label="Selected"
                          data-test="procedure-type-selcected"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {values.procedurTypeRadio === 'SelcectedDateRange' && (
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <SelectionBox
                          selectedValue={values?.procedurTypeSelectedOption}
                          onChangeValues={onChangeValues}
                          ProcedureTypeDropDown={ProcedureTypeDropDown}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend
                  className="same-font-family"
                  tabIndex={0}
                  id="SubmittedByLabel"
                >
                  Submitted By
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      data-test="submitted-by"
                      id="standard-reason-code"
                      label="Submitted By"
                      fullWidth
                      select
                      value={values.submitedBy}
                      placeholder=""
                      inputProps={{
                        maxlength: 11,
                        'aria-labelledby': 'SubmittedByLabel',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      aria-label="SubmittedByLabel"
                      onChange={(e) => {
                        onChangeValues(e, 'submitedBy');
                      }}
                    >
                      <MenuItem selected key="-1" value="DRAMS,RAMS">
                        Self and DRAMS
                      </MenuItem>
                      <MenuItem selected key="1" value="All">
                        All
                      </MenuItem>
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div
              className="mt-4 hide-on-print"
              tabIndex={0}
              style={{ height: '35px' }}
            >
              <Button
                onClick={searchProcedureResult}
                className="btn btn btn-success ml-1 same-font-family"
              >
                <SVGComponent iconName="Create-new-icon" /> Process
              </Button>
            </div>
          </div>
        </div>
        <div className="clearfix" />
      </div>
    </div>
  );
};
export default ProcedureResultForm;
